<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
                <!-- <el-button type="primary" @click="exportOpen()">导出Excel</el-button> -->
            </div>
            <div class="header-right" v-if="pageMap.filter">
                <el-date-picker v-model="monthRange" type="monthrange" format="yyyyMM" value-format="yyyyMM" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" style="margin-right: 10px;" @change="monthRangeChange">
                </el-date-picker>
                <el-input v-for="item in pageMap.filter" v-model="filterParams[item.prop]"
                    :placeholder="'请输入' + item.label" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column prop="inventoryCommonMonth" label="月份" width="90"></el-table-column>
            <el-table-column prop="inventoryCustomerName" label="公司名称" width="300">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCustomerName)">{{ scope.row.inventoryCustomerName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryCustomerPerson" label="负责人">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCustomerPerson)">{{ scope.row.inventoryCustomerPerson }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryCategoryName" label="项目">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCategoryName)">{{ scope.row.inventoryCategoryName }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="inventoryAccountActualUpstream" label="上游金额"></el-table-column> -->
            <el-table-column label="贸易">
                <el-table-column prop="inventoryAccountActualTradeAmount" label="开票金额">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountActualTradeAmount)">{{ scope.row.inventoryAccountActualTradeAmount }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryCategoryPercentUp" label="费率">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCategoryPercentUp)">{{ scope.row.inventoryCategoryPercentUp }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryAccountActualServiceFee" label="服务费">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountActualServiceFee)">{{ scope.row.inventoryAccountActualServiceFee }}</span>
                </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="过夜">
                <el-table-column prop="inventoryAccountActualNightAmount" label="金额">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountActualNightAmount)">{{ scope.row.inventoryAccountActualNightAmount }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryAccountPlanNightRate" label="费率">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanNightRate)">{{ scope.row.inventoryAccountPlanNightRate }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryAccountActualNightFee" label="过夜费">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountActualNightFee)">{{ scope.row.inventoryAccountActualNightFee }}</span>
                </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="利差">
                <el-table-column prop="inventoryAccountPlanProfitRate" label="费率">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanProfitRate)">{{ scope.row.inventoryAccountPlanProfitRate }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryAccountActualProfit" label="利差">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountActualProfit)">{{ scope.row.inventoryAccountActualProfit }}</span>
                </template>
                </el-table-column>
            </el-table-column>
            
            <!-- <el-table-column prop="inventoryCommonNightPercent" label="过夜比例"></el-table-column>
            <el-table-column prop="inventoryCommonNightRate" label="过夜费率"></el-table-column> -->
            
            <el-table-column prop="inventoryAccountActualMemo" label="备注">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountActualMemo)">{{ scope.row.inventoryAccountActualMemo }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryAccountActualTotal" label="合计">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountActualTotal)">{{ scope.row.inventoryAccountActualTotal }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryAccountActualPay" label="预付">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountActualPay)">{{ scope.row.inventoryAccountActualPay }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryAccountActualUnpay" label="剩余">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountActualUnpay)">{{ scope.row.inventoryAccountActualUnpay }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="90">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.inventoryAccountActualStatus != '-' && scope.row.inventoryAccountActualStatus == 1" type="success">已结账</el-tag>
                    <el-tag v-if="scope.row.inventoryAccountActualStatus != '-' && scope.row.inventoryAccountActualStatus == 0" type="error">未结账</el-tag>
                    <span v-if="scope.row.inventoryAccountActualStatus == '-'">-</span>
                </template>
            </el-table-column>
            <!-- 操作栏 -->
            <el-table-column label="操作" width="60">
                <template slot-scope="scope">
                    <div v-if="scope.row.inventoryCommonMonth != '合计'">
                        <el-button @click="handleClick('update', scope.row)" type="text" size="small"
                            v-if="pageMap.handle.update && checkPermissionButton('编辑')">编辑</el-button>
                    </div>
                    <div v-else>-</div>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 1000]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="40%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="100px">
                    <!-- <el-form-item label="上游金额">
                        <el-input v-model="handleInfo.inventoryAccountActualUpstream"></el-input>
                    </el-form-item> -->
                    <el-form-item label="开票金额">
                        <el-input v-model="handleInfo.inventoryAccountActualTradeAmount"></el-input>
                    </el-form-item>
                    <el-form-item label="利差">
                        <el-input v-model="handleInfo.inventoryAccountActualProfit"></el-input>
                    </el-form-item>
                    <el-form-item label="过夜金额">
                        <el-input v-model="handleInfo.inventoryAccountActualNightAmount"></el-input>
                    </el-form-item>
                    <el-form-item label="预付">
                        <el-input v-model="handleInfo.inventoryAccountActualPay"></el-input>
                    </el-form-item>
                    <el-form-item label="台账状态">
                        <el-select v-model="handleInfo.inventoryAccountActualStatus" placeholder="请选择" style="width: 100%;">
                            <el-option label="已结账" :value="1"></el-option>
                            <el-option label="未结账" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="handleInfo.inventoryAccountActualMemo"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 导出弹窗 -->
        <el-dialog title="选择导出设置" :visible.sync="isExport" width="30%">
            <el-checkbox-group v-model="exportChecked">
                <el-checkbox :label="item.name" v-for="item in exportMap"></el-checkbox>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isExport = false">取 消</el-button>
                <el-button type="primary" @click="exportConfirm()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            type: "",
            customers: [],
            monthRange: [],
        }
    },
    methods: {
        monthRangeChange: function(e) {
            this.filterParams.inventory_common_month_start = e[0];
            this.filterParams.inventory_common_month_end = e[1];
            this.loadData(1);
        },
        getCustomers: async function () {
            this.customers = await doGet("/inventoryCustomer" + API.ALL);
        },
        beforeHandleOpenEx: function (handle, info, type) {
            this.type = type;
            if (handle == "update") {
                this.handleInfo.type = type;
            }
        },
        afterInitialData: function () {
            if (this.records && this.records.length > 0) {
                let inventoryAccountActualTradeAmount = 0;
                let inventoryAccountActualProfit = 0;
                let inventoryAccountActualServiceFee = 0;
                let inventoryAccountActualNightAmount = 0;
                let inventoryAccountActualNightFee = 0;
                let inventoryAccountActualTotal = 0;
                for (let i = 0; i < this.records.length; i++) {
                    inventoryAccountActualTradeAmount += this.records[i].inventoryAccountActualTradeAmount;
                    inventoryAccountActualProfit += this.records[i].inventoryAccountActualProfit;
                    inventoryAccountActualServiceFee += this.records[i].inventoryAccountActualServiceFee;
                    inventoryAccountActualNightAmount += this.records[i].inventoryAccountActualNightAmount;
                    inventoryAccountActualNightFee += this.records[i].inventoryAccountActualNightFee;
                    inventoryAccountActualTotal += this.records[i].inventoryAccountActualTotal;
                }
                this.records.push({
                    inventoryCommonMonth: '合计',
                    inventoryCustomerName: '-',
                    inventoryCustomerPerson: '-',
                    inventoryCategoryName: '-',
                    inventoryAccountActualTradeAmount: inventoryAccountActualTradeAmount.toFixed(1),
                    inventoryAccountActualProfit: inventoryAccountActualProfit.toFixed(1),
                    inventoryCategoryPercentUp: '-',
                    inventoryAccountActualServiceFee: inventoryAccountActualServiceFee.toFixed(1),
                    inventoryCommonNightPercent: '-',
                    inventoryCommonNightRate: '-',
                    inventoryAccountActualNightAmount: inventoryAccountActualNightAmount.toFixed(1),
                    inventoryAccountActualNightFee: inventoryAccountActualNightFee.toFixed(1),
                    inventoryAccountActualMemo: '-',
                    inventoryAccountActualTotal: inventoryAccountActualTotal.toFixed(1)
                });
            }
        }
    },
    created: function () {
        this.tag = "inventoryPayment";
        this.getCustomers();
        this.exportMap = [
            //COMMON
            { name: "月份", value: "inventoryCommonMonth", checked: true }, 
            { name: "公司名称", value: "inventoryCustomerName", checked: true }, 
            { name: "负责人", value: "inventoryCustomerPerson", checked: true }, 
            { name: "项目", value: "inventoryCategoryName", checked: true },  
            //上游实际
            { name: "实际开票金额", value: "inventoryAccountActualTradeAmount", checked: true }, 
            { name: "上游费率", value: "inventoryCategoryPercentUp", checked: true }, 
            { name: "上游实际贸易服务费", value: "inventoryAccountActualServiceFee", checked: true }, 
            { name: "上游实际利差费率", value: "inventoryAccountPlanProfitRate", checked: true }, 
            { name: "上游实际利差", value: "inventoryAccountActualProfit", checked: true }, 
            { name: "上游实际过夜金额", value: "inventoryAccountActualNightAmount", checked: true }, 
            { name: "上游实际过夜费率", value: "inventoryAccountPlanNightRate", checked: true },
            { name: "上游实际过夜费", value: "inventoryAccountActualNightFee", checked: true }, 
            { name: "上游实际备注", value: "inventoryAccountActualMemo", checked: true }, 
            { name: "上游实际合计", value: "inventoryAccountActualTotal", checked: true }, 
            { name: "上游实际预付", value: "inventoryAccountActualPay", checked: true }, 
            { name: "上游实际剩余", value: "inventoryAccountActualUnpay", checked: true }, 
        ];
    },
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>